import {
  Timestamp,
  deleteDoc,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { ReactionsRef, db } from "../../../firebase";
// import moment from "moment";
import {
  getSingleQuickTale,
  getSingleUser,
} from "../../OrganizationQuickTales/hooks/QuickTalesHooks";

export const getAllReactions = async () => {
  try {
    const response = await getDocs(ReactionsRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getOrgReactions = async (organizationId) => {
  try {
    const q = query(ReactionsRef, where("organization", "==", organizationId));
    const response = await getDocs(q);
    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const deleteReaction = async (id) => {
  const reactionDocRef = doc(db, "quicktaleReaction", id);
  return await deleteDoc(reactionDocRef);
};

export const updateReaction = async (id, reaction) => {
  const reactionDocRef = doc(db, "quicktaleReaction", id);
  return await updateDoc(reactionDocRef, reaction);
};

export const ReactionsSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value.quicktaleData.title &&
        value.quicktaleData.title
          .toLowerCase()
          .match(new RegExp(searchTerm, "g"))) ||
      (value.userData.userName &&
        value.userData.userName
          .toLowerCase()
          .match(new RegExp(searchTerm, "g"))) ||
      (value.qtCreatedByData.userName &&
        value.qtCreatedByData.userName
          .toLowerCase()
          .match(new RegExp(searchTerm, "g")))
    );
  });
};

export const getFilterReactions = async (
  statusFilterOptions,
  // creationDateFilterOptions,
  creationDateRange,
  setLoading,
  handleFilterModalClose
) => {
  // setLoading(true); // Uncomment this if needed

  // Function to deduplicate documents based on their IDs
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    return uniqueDocs;
  };

  try {
    // Construct the initial query with "Who Can Listen" and "QT Status" filters
    let queries = [
      ...statusFilterOptions.map((option) => where("status", "==", option)),
    ];

    if (
      creationDateRange &&
      creationDateRange?.startDate &&
      creationDateRange?.endDate
    ) {
      queries.push(
        where(
          "createdAt",
          ">=",
          Timestamp.fromDate(creationDateRange.startDate)
        )
      );
      queries.push(
        where("createdAt", "<=", Timestamp.fromDate(creationDateRange.endDate))
      );
    }

    // // Add date range filter if provided
    // if (creationDateFilterOptions.length > 0) {
    //   let selectedDateOption;

    //   if (Array.isArray(creationDateFilterOptions)) {
    //     // Example of finding a specific option, adjust logic as necessary
    //     const dateRangeOption = creationDateFilterOptions.find((option) =>
    //       option.startsWith("Creation Date:")
    //     );
    //     if (dateRangeOption) {
    //       selectedDateOption = "Custom Range"; // Indicate a custom range is selected
    //     } else {
    //       // Logic to set selectedDateOption based on other criteria
    //       selectedDateOption = creationDateFilterOptions[0]; // Example defaulting to the first option
    //     }
    //   } else {
    //     selectedDateOption = creationDateFilterOptions; // Directly use the string if it's not an array
    //   }

    //   switch (selectedDateOption) {
    //     case "Custom Range":
    //       const dateRangeOption = creationDateFilterOptions.find((option) =>
    //         option.startsWith("Creation Date:")
    //       );
    //       const dates = dateRangeOption
    //         .replace("Creation Date: ", "")
    //         .split(" - ");
    //       const startDate = moment(dates[0], "MM/DD/YYYY")
    //         .startOf("day")
    //         .toDate();
    //       const endDate = moment(dates[1], "MM/DD/YYYY").endOf("day").toDate();

    //       // Add date range conditions to the query
    //       queries.push(where("createdAt", ">=", Timestamp.fromDate(startDate)));
    //       queries.push(where("createdAt", "<=", Timestamp.fromDate(endDate)));
    //       break;
    //     case "Today":
    //       const todayStart = moment(new Date(), "MM/DD/YYYY")
    //         .startOf("day")
    //         .toDate();
    //       const todayEnd = moment(new Date(), "MM/DD/YYYY")
    //         .endOf("day")
    //         .toDate();
    //       queries.push(
    //         where("createdAt", ">=", Timestamp.fromDate(todayStart))
    //       );
    //       queries.push(where("createdAt", "<=", Timestamp.fromDate(todayEnd)));
    //       break;
    //     case "Past Week":
    //       const lastWeekStart = moment(new Date(), "MM/DD/YYYY")
    //         .subtract(7, "days")
    //         .startOf("day")
    //         .toDate();
    //       const lastWeekEnd = moment(new Date(), "MM/DD/YYYY")
    //         .endOf("day")
    //         .toDate();
    //       queries.push(
    //         where("createdAt", ">=", Timestamp.fromDate(lastWeekStart))
    //       );
    //       queries.push(
    //         where("createdAt", "<=", Timestamp.fromDate(lastWeekEnd))
    //       );
    //       break;
    //     case "Last 30 Days":
    //       const last30DaysStart = moment(new Date(), "MM/DD/YYYY")
    //         .subtract(30, "days")
    //         .startOf("day")
    //         .toDate();
    //       const last30DaysEnd = moment(new Date(), "MM/DD/YYYY")
    //         .endOf("day")
    //         .toDate();
    //       queries.push(
    //         where("createdAt", ">=", Timestamp.fromDate(last30DaysStart))
    //       );
    //       queries.push(
    //         where("createdAt", "<=", Timestamp.fromDate(last30DaysEnd))
    //       );
    //       break;
    //     case "Last 12 Months":
    //       const last12MonthsStart = moment(new Date(), "MM/DD/YYYY")
    //         .subtract(12, "months")
    //         .startOf("day")
    //         .toDate();
    //       const last12MonthsEnd = moment(new Date(), "MM/DD/YYYY")
    //         .endOf("day")
    //         .toDate();
    //       queries.push(
    //         where("createdAt", ">=", Timestamp.fromDate(last12MonthsStart))
    //       );
    //       queries.push(
    //         where("createdAt", "<=", Timestamp.fromDate(last12MonthsEnd))
    //       );
    //       break;
    //     default:
    //       // Default case
    //       break;
    //   }
    // }

    // Execute the query
    const q = query(ReactionsRef, ...queries);
    const querySnapshot = await getDocs(q);

    // Convert to map to handle async operations
    const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
      const quicktaleTemp = await getSingleQuickTale(doc.data().quicktale);
      const qtCreatedUserTemp = await getSingleUser(
        quicktaleTemp?.data()?.createdBy
      );
      const userTemp = await getSingleUser(doc.data().user);

      return {
        id: doc.id,
        ...doc.data(),
        quicktaleData: quicktaleTemp?.data() ? quicktaleTemp.data() : {},
        userData: userTemp?.data() ? userTemp.data() : {},
        qtCreatedByData: qtCreatedUserTemp?.data()
          ? qtCreatedUserTemp.data()
          : {},
      };
    });

    // Wait for all fetches to complete
    const results = await Promise.all(fetchDetailsPromises);

    // Deduplicate the results before returning
    const uniqueResults = deduplicate(results);
    handleFilterModalClose(); // Assuming it's appropriate to close the modal here
    return uniqueResults;
  } catch (error) {
    console.error("Error filtering QuickTales:", error);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};

export const getFilterOrgReactions = async (
  statusFilterOptions,
  creationDateRange,
  setLoading,
  handleFilterModalClose,
  organization
) => {
  setLoading(true);

  // Function to deduplicate documents based on their IDs
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    return uniqueDocs;
  };

  try {
    let results = [];

    const statusOptions =
      statusFilterOptions.length > 0 ? statusFilterOptions : [null];

    for (const status of statusOptions) {
      let queries = [];

      if (status !== null) {
        queries.push(where("status", "==", status));
      }

      if (
        creationDateRange &&
        creationDateRange.startDate &&
        creationDateRange.endDate
      ) {
        queries.push(where("createdAt", ">=", creationDateRange.startDate));
        queries.push(where("createdAt", "<=", creationDateRange.endDate));
      }

      if (organization) {
        queries.push(where("organization", "==", organization));
      }

      if (queries.length > 0) {
        const q = query(ReactionsRef, ...queries);
        const querySnapshot = await getDocs(q);
        console.log("results:", querySnapshot.docs[0]?.data());

        const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
          const quicktaleTemp = await getSingleQuickTale(doc.data().quicktale);
          const qtCreatedUserTemp = await getSingleUser(
            quicktaleTemp?.data()?.createdBy
          );
          const userTemp = await getSingleUser(doc.data().user);

          return {
            id: doc.id,
            ...doc.data(),
            quicktaleData: quicktaleTemp?.data() ? quicktaleTemp.data() : {},
            userData: userTemp?.data() ? userTemp.data() : {},
            qtCreatedByData: qtCreatedUserTemp?.data()
              ? qtCreatedUserTemp.data()
              : {},
          };
        });

        // Wait for all fetches to complete
        const queryResults = await Promise.all(fetchDetailsPromises);
        results = results.concat(queryResults);
      }
    }
    const uniqueResults = deduplicate(results);
    handleFilterModalClose(); // Assuming it's appropriate to close the modal here
    return uniqueResults;
    // // let results = [];

    // let baseQuery = query(
    //   ReactionsRef,
    //   where("organization", "==", organization)
    //   // where("organization", "array-contains", organization)
    // );

    // // Apply 'Who Can Listen' filters
    // statusFilterOptions.forEach((option) => {
    //   baseQuery = query(baseQuery, where("status", "==", option));
    // });

    // if (
    //   creationDateRange &&
    //   creationDateRange?.startDate &&
    //   creationDateRange?.endDate
    // ) {
    //   baseQuery = query(
    //     baseQuery,
    //     where(
    //       "createdAt",
    //       ">=",
    //       Timestamp.fromDate(creationDateRange.startDate)
    //     )
    //   );
    //   baseQuery = query(
    //     baseQuery,
    //     where("createdAt", "<=", Timestamp.fromDate(creationDateRange.endDate))
    //   );
    // }

    // // Execute the query
    // // const q = query(ReactionsRef, ...queries);
    // // const querySnapshot = await getDocs(q);
    // const querySnapshot = await getDocs(baseQuery);

    // // Convert to map to handle async operations
    // const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
    //   const quicktaleTemp = await getSingleQuickTale(doc.data().quicktale);
    //   const qtCreatedUserTemp = await getSingleUser(
    //     quicktaleTemp?.data()?.createdBy
    //   );
    //   const userTemp = await getSingleUser(doc.data().user);

    //   return {
    //     id: doc.id,
    //     ...doc.data(),
    //     quicktaleData: quicktaleTemp?.data() ? quicktaleTemp.data() : {},
    //     userData: userTemp?.data() ? userTemp.data() : {},
    //     qtCreatedByData: qtCreatedUserTemp?.data()
    //       ? qtCreatedUserTemp.data()
    //       : {},
    //   };
    // });

    // // Wait for all fetches to complete
    // const results = await Promise.all(fetchDetailsPromises);

    // Deduplicate the results before returning
    // const uniqueResults = deduplicate(results);
    // handleFilterModalClose(); // Assuming it's appropriate to close the modal here
    // return uniqueResults;
  } catch (error) {
    console.error("Error filtering QuickTales:", error);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};

// export const getFilterReactions = async (
//   statusFilterOptions,
//   creationDateFilterOptions,
//   setLoading,
//   handleFilterModalClose
// ) => {
//   let results = [];
//   // setLoading(true)

//   // Function to deduplicate documents based on their IDs
//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     handleFilterModalClose();
//     return uniqueDocs;
//   };

//   try {
//     // Construct the initial query with "Who Can Listen" and "QT Status" filters
//     let queries = [
//       ...statusFilterOptions.map((option) => where("status", "==", option)),
//     ];

//     // Add date range filter if provided
//     if (creationDateFilterOptions.length > 0) {
//       const dateRangeString = creationDateFilterOptions.find((option) =>
//         option.startsWith("Creation Date:")
//       );
//       if (dateRangeString) {
//         const dates = dateRangeString
//           .replace("Creation Date: ", "")
//           .split(" - ");
//         const startDate = moment(dates[0], "MM/DD/YYYY")
//           .startOf("day")
//           .toDate();
//         const endDate = moment(dates[1], "MM/DD/YYYY").endOf("day").toDate();

//         // Add date range conditions to the query
//         queries.push(where("createdAt", ">=", Timestamp.fromDate(startDate)));
//         queries.push(where("createdAt", "<=", Timestamp.fromDate(endDate)));
//       }
//     }

//     // Execute the query
//     const q = query(ReactionsRef, ...queries);
//     const querySnapshot = await getDocs(q);
//     querySnapshot.forEach(async (doc) => {
//       let quicktaleTemp = await getSingleQuickTale(doc.data().quicktale);

//       let qtCreatedUserTemp = await getSingleUser(
//         quicktaleTemp?.data()?.createdBy
//       );
//       let userTemp = await getSingleUser(doc?.data()?.user);
//       results.push({
//         id: doc.id,
//         ...doc.data(),
//         quicktaleData: quicktaleTemp?.data() ? quicktaleTemp?.data() : {},
//         userData: userTemp?.data() ? userTemp?.data() : {},
//         qtCreatedByData: qtCreatedUserTemp?.data()
//           ? qtCreatedUserTemp?.data()
//           : {},
//       });
//     });

//     // Deduplicate the results before returning
//     return deduplicate(results);
//   } catch (error) {
//     console.error("Error filtering QuickTales:", error);
//     return []; // Return an empty array in case of error
//   } finally {
//     setLoading(false);
//   }
// };
